// Ordering useFrame callbacks here
export const CALLBACK_ORDER_FRAME_TIMINGS = -900;
export const CALLBACK_ORDER_CAMERA_MOVER = -800;
export const CALLBACK_ORDER_AFTER_CAMERA_UPDATE = -790;
export const CALLBACK_ORDER_BILLBOARD = -700;
export const CALLBACK_ORDER_TEXT_LABEL = -600;
export const CALLBACK_ORDER_WEBGL_BENCHMARK = -100;
// render EDL-shades right before screen render call
export const CALLBACK_ORDER_EDL_SHADES = -1;
